import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon'

function SbirSttrLogoIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fill='#89B9E0'
        d='M55.595,38.748c-0.685,0.458-1.622,0.29-2.094-0.377c-0.471-0.666-0.298-1.578,0.387-2.037
	c0.685-0.458,1.623-0.29,2.094,0.377C56.454,37.378,56.281,38.29,55.595,38.748z'
      />
      <path
        fill='#D17363'
        d='M37.858,2.399c-0.615,0.412-1.457,0.26-1.88-0.338c-0.423-0.599-0.267-1.417,0.348-1.829
	c0.615-0.412,1.458-0.26,1.88,0.338C38.629,1.168,38.473,1.987,37.858,2.399z'
      />
      <path
        fill='#C85248'
        d='M42.753,7.046c-0.685,0.458-1.623,0.29-2.094-0.376s-0.298-1.579,0.387-2.037
	c0.685-0.459,1.623-0.29,2.094,0.376C43.612,5.675,43.438,6.587,42.753,7.046z'
      />
      <path
        fill='#645C8A'
        d='M47.633,12.417c-0.742,0.699-1.926,0.68-2.645-0.042s-0.7-1.873,0.042-2.572s1.926-0.681,2.645,0.042
	C48.395,10.566,48.375,11.718,47.633,12.417z'
      />
      <path
        fill='#56A3D5'
        d='M58.043,33.216c-0.742,0.699-1.926,0.68-2.645-0.042c-0.718-0.722-0.7-1.873,0.042-2.573
	c0.742-0.699,1.926-0.68,2.645,0.042S58.786,32.517,58.043,33.216z'
      />
      <path
        fill='#2073AE'
        d='M56.867,27.053c-1.187,0.794-2.811,0.502-3.627-0.652c-0.816-1.154-0.517-2.733,0.67-3.527
	c1.187-0.794,2.811-0.502,3.627,0.652C58.354,24.679,58.054,26.259,56.867,27.053z'
      />
      <path
        fill='#264983'
        d='M53.285,20.429c-1.548,1.036-3.666,0.655-4.73-0.851c-1.065-1.505-0.673-3.565,0.875-4.601
	c1.548-1.035,3.666-0.654,4.73,0.851C55.224,17.333,54.833,19.393,53.285,20.429z'
      />
      <path
        fill='#89B9E0'
        d='M53.191,33.084c-0.358,0.73-1.257,1.04-2.007,0.692c-0.75-0.348-1.069-1.222-0.711-1.952
	c0.357-0.73,1.256-1.041,2.007-0.692C53.23,31.48,53.549,32.354,53.191,33.084z'
      />
      <path
        fill='#D17363'
        d='M19.143,10.23c-0.321,0.655-1.128,0.934-1.802,0.621c-0.674-0.312-0.96-1.097-0.64-1.752
	c0.322-0.656,1.128-0.934,1.802-0.622C19.178,8.79,19.464,9.575,19.143,10.23z'
      />
      <path
        fill='#C85248'
        d='M25.771,11.875c-0.357,0.73-1.256,1.04-2.007,0.692s-1.07-1.222-0.712-1.952s1.257-1.04,2.007-0.692
	C25.81,10.27,26.129,11.144,25.771,11.875z'
      />
      <path
        fill='#645C8A'
        d='M32.759,14.152c-0.284,0.966-1.319,1.526-2.312,1.251c-0.994-0.276-1.569-1.283-1.286-2.249
	c0.283-0.966,1.318-1.526,2.312-1.25C32.466,12.18,33.042,13.186,32.759,14.152z'
      />
      <path
        fill='#56A3D5'
        d='M52.467,27.103c-0.283,0.966-1.318,1.526-2.312,1.25c-0.993-0.275-1.568-1.282-1.286-2.248
	c0.284-0.966,1.319-1.526,2.312-1.25C52.175,25.13,52.75,26.137,52.467,27.103z'
      />
      <path
        fill='#2073AE'
        d='M48.28,22.337c-0.62,1.265-2.177,1.802-3.477,1.2c-1.3-0.603-1.853-2.117-1.233-3.382
	c0.62-1.265,2.176-1.801,3.476-1.199C48.347,19.559,48.899,21.073,48.28,22.337z'
      />
      <path
        fill='#264983'
        d='M41.771,18.343c-0.808,1.649-2.838,2.35-4.534,1.563c-1.696-0.786-2.416-2.76-1.608-4.409
	c0.808-1.649,2.838-2.35,4.534-1.564C41.86,14.72,42.58,16.694,41.771,18.343z'
      />
      <path
        fill='#89B9E0'
        d='M47.467,28.963c0.066,0.806-0.553,1.512-1.382,1.576c-0.829,0.063-1.554-0.538-1.62-1.345
	c-0.065-0.806,0.554-1.512,1.382-1.576C46.676,27.555,47.402,28.157,47.467,28.963z'
      />
      <path
        fill='#D17363'
        d='M6.231,25.728c0.06,0.725-0.497,1.357-1.241,1.415c-0.744,0.057-1.396-0.483-1.454-1.208
	c-0.06-0.724,0.496-1.357,1.241-1.415S6.172,25.003,6.231,25.728z'
      />
      <path
        fill='#C85248'
        d='M12.817,23.928c0.065,0.807-0.553,1.512-1.382,1.576c-0.829,0.064-1.554-0.538-1.62-1.344
	c-0.065-0.807,0.553-1.512,1.382-1.576S12.751,23.122,12.817,23.928z'
      />
      <path
        fill='#645C8A'
        d='M20.039,22.503c0.251,0.975-0.357,1.963-1.359,2.208c-1.002,0.244-2.018-0.348-2.27-1.322
	s0.357-1.963,1.359-2.207C18.771,20.937,19.788,21.529,20.039,22.503z'
      />
      <path
        fill='#56A3D5'
        d='M43.765,24.135c0.251,0.975-0.357,1.963-1.359,2.208c-1.002,0.244-2.018-0.348-2.27-1.322
	c-0.251-0.975,0.357-1.962,1.359-2.207S43.514,23.16,43.765,24.135z'
      />
      <path
        fill='#2073AE'
        d='M37.689,22.044c0.113,1.396-0.958,2.618-2.395,2.729c-1.436,0.11-2.692-0.932-2.806-2.329
	s0.958-2.619,2.395-2.729S37.575,20.648,37.689,22.044z'
      />
      <path
        fill='#264983'
        d='M29.999,21.75c0.148,1.821-1.25,3.415-3.123,3.559c-1.873,0.145-3.511-1.215-3.659-3.037
	c-0.148-1.822,1.25-3.415,3.123-3.559S29.851,19.929,29.999,21.75z'
      />
      <path
        fill='#89B9E0'
        d='M40.97,28.38c0.472,0.667,0.298,1.578-0.387,2.037c-0.685,0.458-1.622,0.29-2.094-0.377
	c-0.471-0.666-0.298-1.578,0.387-2.037C39.561,27.545,40.499,27.714,40.97,28.38z'
      />
      <path
        fill='#D17363'
        d='M3.595,45.631c0.423,0.599,0.268,1.417-0.348,1.829s-1.457,0.26-1.88-0.338S1.1,45.705,1.715,45.293
	S3.172,45.033,3.595,45.631z'
      />
      <path
        fill='#C85248'
        d='M8.374,40.87c0.471,0.667,0.298,1.579-0.387,2.037c-0.686,0.458-1.623,0.29-2.094-0.376
	c-0.471-0.667-0.298-1.578,0.387-2.037S7.902,40.204,8.374,40.87z'
      />
      <path
        fill='#645C8A'
        d='M13.896,36.124c0.718,0.722,0.699,1.874-0.043,2.573c-0.742,0.699-1.926,0.68-2.645-0.042
	c-0.719-0.722-0.7-1.874,0.042-2.572C11.993,35.384,13.177,35.402,13.896,36.124z'
      />
      <path
        fill='#56A3D5'
        d='M35.281,26c0.719,0.722,0.7,1.874-0.042,2.573c-0.742,0.699-1.926,0.68-2.645-0.042s-0.7-1.874,0.042-2.573
	C33.378,25.259,34.563,25.278,35.281,26z'
      />
      <path
        fill='#2073AE'
        d='M28.945,27.144c0.816,1.155,0.517,2.734-0.67,3.528s-2.811,0.502-3.627-0.652
	c-0.816-1.154-0.516-2.734,0.671-3.528C26.504,25.698,28.128,25.99,28.945,27.144z'
      />
      <path
        fill='#264983'
        d='M22.134,30.628c1.065,1.505,0.673,3.565-0.875,4.601c-1.548,1.036-3.666,0.655-4.73-0.851
	c-1.064-1.505-0.673-3.565,0.875-4.601S21.069,29.123,22.134,30.628z'
      />
      <path
        fill='#89B9E0'
        d='M34.844,31.191c0.755,0.339,1.084,1.209,0.735,1.944c-0.349,0.734-1.243,1.055-1.998,0.715
	c-0.755-0.339-1.085-1.209-0.736-1.943C33.194,31.173,34.089,30.853,34.844,31.191z'
      />
      <path
        fill='#D17363'
        d='M11.753,64.576c0.678,0.305,0.974,1.086,0.661,1.746c-0.313,0.659-1.117,0.947-1.794,0.642
	c-0.679-0.305-0.974-1.086-0.661-1.745C10.272,64.56,11.076,64.271,11.753,64.576z'
      />
      <path
        fill='#C85248'
        d='M13.365,58.11c0.755,0.34,1.084,1.209,0.736,1.944c-0.349,0.735-1.244,1.055-1.999,0.716
	c-0.755-0.339-1.084-1.209-0.735-1.944C11.715,58.092,12.61,57.772,13.365,58.11z'
      />
      <path
        fill='#645C8A'
        d='M15.624,51.289c0.997,0.264,1.585,1.264,1.313,2.233c-0.271,0.97-1.3,1.542-2.297,1.278
	c-0.997-0.264-1.584-1.264-1.313-2.234C13.599,51.596,14.627,51.024,15.624,51.289z'
      />
      <path
        fill='#56A3D5'
        d='M28.703,31.967c0.997,0.264,1.585,1.264,1.313,2.233s-1.3,1.541-2.296,1.277
	c-0.997-0.264-1.584-1.264-1.313-2.233C26.678,32.275,27.706,31.703,28.703,31.967z'
      />
      <path
        fill='#2073AE'
        d='M23.854,36.097c1.308,0.587,1.878,2.094,1.274,3.366s-2.154,1.827-3.461,1.239
	c-1.308-0.587-1.878-2.095-1.274-3.366C20.996,36.064,22.546,35.509,23.854,36.097z'
      />
      <path
        fill='#264983'
        d='M19.825,42.473c1.705,0.767,2.449,2.732,1.662,4.391s-2.809,2.382-4.514,1.616s-2.45-2.732-1.662-4.391
	S18.119,41.707,19.825,42.473z'
      />
      <path
        fill='#89B9E0'
        d='M31.312,36.034c0.828-0.073,1.561,0.52,1.637,1.325c0.075,0.806-0.535,1.518-1.363,1.592
	c-0.828,0.073-1.561-0.521-1.636-1.326C29.874,36.82,30.484,36.107,31.312,36.034z'
      />
      <path
        fill='#D17363'
        d='M28.479,76.175c0.744-0.066,1.401,0.467,1.469,1.19c0.067,0.723-0.48,1.362-1.224,1.429
	c-0.744,0.066-1.402-0.467-1.47-1.19C27.187,76.881,27.735,76.241,28.479,76.175z'
      />
      <path
        fill='#C85248'
        d='M26.55,69.792c0.828-0.073,1.561,0.52,1.636,1.325c0.075,0.806-0.535,1.519-1.363,1.592
	c-0.829,0.073-1.561-0.521-1.637-1.326C25.112,70.578,25.722,69.865,26.55,69.792z'
      />
      <path
        fill='#645C8A'
        d='M24.999,62.785c0.999-0.256,2.022,0.324,2.286,1.296s-0.333,1.967-1.332,2.223
	c-0.999,0.256-2.022-0.324-2.285-1.296C23.403,64.037,24,63.041,24.999,62.785z'
      />
      <path
        fill='#56A3D5'
        d='M26.393,39.692c0.999-0.256,2.022,0.324,2.286,1.295c0.263,0.972-0.333,1.967-1.332,2.223
	c-0.999,0.255-2.022-0.324-2.286-1.296C24.797,40.944,25.394,39.948,26.393,39.692z'
      />
      <path
        fill='#2073AE'
        d='M24.316,45.626c1.435-0.127,2.704,0.901,2.834,2.296s-0.926,2.629-2.361,2.756
	c-1.435,0.127-2.704-0.901-2.834-2.296C21.825,46.987,22.881,45.753,24.316,45.626z'
      />
      <path
        fill='#264983'
        d='M24.104,53.108c1.871-0.166,3.526,1.174,3.697,2.994s-1.208,3.429-3.079,3.595
	c-1.871,0.166-3.526-1.175-3.697-2.995C20.855,54.883,22.234,53.274,24.104,53.108z'
      />
      <path
        fill='#89B9E0'
        d='M33.437,47.767c0.358-0.73,1.257-1.04,2.007-0.692c0.751,0.348,1.069,1.222,0.712,1.952
	c-0.358,0.73-1.256,1.04-2.007,0.692C33.397,49.371,33.079,48.497,33.437,47.767z'
      />
      <path
        fill='#D17363'
        d='M67.485,70.62c0.322-0.655,1.128-0.934,1.802-0.621c0.674,0.312,0.96,1.098,0.64,1.753
	c-0.322,0.655-1.128,0.934-1.802,0.621C67.45,72.061,67.164,71.276,67.485,70.62z'
      />
      <path
        fill='#C85248'
        d='M60.857,68.977c0.357-0.729,1.256-1.04,2.007-0.692c0.751,0.349,1.07,1.222,0.712,1.952
	s-1.256,1.04-2.007,0.692C60.818,70.581,60.499,69.707,60.857,68.977z'
      />
      <path
        fill='#645C8A'
        d='M53.869,66.698c0.284-0.966,1.319-1.525,2.312-1.25c0.994,0.275,1.569,1.282,1.286,2.249
	c-0.283,0.966-1.318,1.526-2.312,1.25C54.162,68.671,53.586,67.665,53.869,66.698z'
      />
      <path
        fill='#56A3D5'
        d='M34.161,53.748c0.283-0.966,1.318-1.526,2.312-1.25c0.993,0.276,1.569,1.283,1.286,2.249
	c-0.284,0.966-1.319,1.526-2.312,1.25C34.454,55.721,33.877,54.714,34.161,53.748z'
      />
      <path
        fill='#2073AE'
        d='M38.349,58.513c0.62-1.265,2.176-1.801,3.477-1.199s1.852,2.116,1.232,3.381s-2.176,1.801-3.476,1.199
	C38.281,61.292,37.729,59.778,38.349,58.513z'
      />
      <path
        fill='#264983'
        d='M44.856,62.508c0.808-1.65,2.838-2.35,4.534-1.564c1.696,0.786,2.416,2.76,1.608,4.41
	c-0.808,1.649-2.838,2.35-4.534,1.563C44.768,66.131,44.048,64.157,44.856,62.508z'
      />
      <path
        fill='#89B9E0'
        d='M38.627,51.635c-0.065-0.807,0.553-1.512,1.382-1.576s1.554,0.538,1.62,1.344
	c0.065,0.807-0.554,1.512-1.382,1.576C39.418,53.043,38.693,52.441,38.627,51.635z'
      />
      <path
        fill='#D17363'
        d='M79.864,54.87c-0.059-0.725,0.497-1.358,1.241-1.415c0.745-0.058,1.396,0.483,1.455,1.207
	c0.059,0.724-0.497,1.357-1.242,1.415C80.574,56.134,79.922,55.594,79.864,54.87z'
      />
      <path
        fill='#C85248'
        d='M73.278,56.669c-0.065-0.806,0.554-1.511,1.382-1.576c0.829-0.063,1.554,0.539,1.62,1.345
	c0.066,0.806-0.553,1.511-1.382,1.575C74.069,58.077,73.344,57.476,73.278,56.669z'
      />
      <path
        fill='#645C8A'
        d='M66.056,58.094c-0.251-0.975,0.357-1.962,1.359-2.207c1.001-0.245,2.018,0.348,2.269,1.322
	c0.251,0.974-0.357,1.962-1.359,2.207C67.323,59.66,66.307,59.068,66.056,58.094z'
      />
      <path
        fill='#56A3D5'
        d='M42.33,56.462c-0.251-0.975,0.357-1.962,1.359-2.207c1.002-0.245,2.018,0.347,2.27,1.322
	c0.251,0.975-0.357,1.963-1.359,2.208C43.597,58.029,42.581,57.437,42.33,56.462z'
      />
      <path
        fill='#2073AE'
        d='M48.406,58.553c-0.113-1.397,0.958-2.619,2.394-2.729c1.436-0.111,2.692,0.932,2.806,2.329
	s-0.958,2.618-2.395,2.729C49.776,60.992,48.52,59.95,48.406,58.553z'
      />
      <path
        fill='#264983'
        d='M56.095,58.848c-0.148-1.822,1.25-3.415,3.123-3.559c1.873-0.144,3.511,1.216,3.659,3.037
	c0.148,1.822-1.25,3.415-3.123,3.559C57.882,62.029,56.244,60.669,56.095,58.848z'
      />
      <path
        fill='#89B9E0'
        d='M45.779,52.337c-0.472-0.666-0.298-1.578,0.387-2.036c0.685-0.458,1.622-0.29,2.094,0.376
	c0.471,0.667,0.298,1.578-0.387,2.037C47.188,53.172,46.25,53.003,45.779,52.337z'
      />
      <path
        fill='#D17363'
        d='M83.154,35.086c-0.423-0.598-0.268-1.417,0.348-1.829s1.457-0.26,1.88,0.338
	c0.423,0.599,0.268,1.417-0.348,1.829C84.419,35.836,83.577,35.685,83.154,35.086z'
      />
      <path
        fill='#C85248'
        d='M78.375,39.847c-0.471-0.667-0.298-1.578,0.387-2.037s1.623-0.29,2.094,0.377
	c0.471,0.666,0.298,1.578-0.387,2.036C79.784,40.682,78.847,40.514,78.375,39.847z'
      />
      <path
        fill='#645C8A'
        d='M72.853,44.593c-0.718-0.722-0.699-1.873,0.043-2.573c0.742-0.699,1.926-0.68,2.645,0.042
	c0.719,0.722,0.7,1.874-0.042,2.573S73.572,45.315,72.853,44.593z'
      />
      <path
        fill='#56A3D5'
        d='M51.468,54.718c-0.719-0.722-0.7-1.873,0.042-2.572c0.742-0.699,1.926-0.68,2.645,0.042
	s0.7,1.874-0.042,2.572C53.371,55.458,52.186,55.439,51.468,54.718z'
      />
      <path
        fill='#2073AE'
        d='M57.804,53.574c-0.816-1.154-0.517-2.734,0.67-3.528s2.811-0.502,3.627,0.652
	c0.816,1.154,0.516,2.734-0.671,3.528C60.245,55.02,58.621,54.728,57.804,53.574z'
      />
      <path
        fill='#264983'
        d='M64.615,50.09c-1.064-1.505-0.673-3.565,0.875-4.601c1.548-1.035,3.666-0.655,4.73,0.851
	c1.064,1.505,0.673,3.565-0.875,4.6C67.798,51.976,65.68,51.595,64.615,50.09z'
      />
      <path
        fill='#89B9E0'
        d='M51.375,49.604c-0.755-0.339-1.084-1.209-0.735-1.943c0.349-0.735,1.243-1.055,1.999-0.716
	c0.755,0.339,1.084,1.209,0.735,1.943C53.025,49.623,52.13,49.943,51.375,49.604z'
      />
      <path
        fill='#D17363'
        d='M74.465,16.219c-0.678-0.305-0.974-1.086-0.661-1.746c0.313-0.659,1.117-0.947,1.794-0.642
	c0.678,0.304,0.974,1.086,0.661,1.745C75.946,16.236,75.143,16.523,74.465,16.219z'
      />
      <path
        fill='#C85248'
        d='M72.854,22.685c-0.755-0.339-1.084-1.209-0.736-1.943s1.244-1.055,1.999-0.716
	c0.755,0.339,1.084,1.209,0.736,1.944C74.503,22.704,73.609,23.024,72.854,22.685z'
      />
      <path
        fill='#645C8A'
        d='M70.595,29.507c-0.997-0.264-1.584-1.264-1.313-2.233c0.271-0.97,1.3-1.542,2.296-1.278
	c0.997,0.264,1.585,1.264,1.313,2.234C72.62,29.199,71.592,29.771,70.595,29.507z'
      />
      <path
        fill='#56A3D5'
        d='M57.516,48.828c-0.997-0.264-1.585-1.264-1.313-2.233s1.299-1.541,2.296-1.277
	c0.997,0.264,1.584,1.264,1.313,2.233C59.541,48.521,58.513,49.092,57.516,48.828z'
      />
      <path
        fill='#2073AE'
        d='M62.365,44.699c-1.308-0.588-1.878-2.095-1.274-3.367c0.604-1.272,2.154-1.827,3.461-1.239
	s1.878,2.095,1.274,3.366C65.223,44.731,63.673,45.287,62.365,44.699z'
      />
      <path
        fill='#264983'
        d='M66.394,38.323c-1.705-0.767-2.449-2.732-1.662-4.391c0.788-1.659,2.809-2.382,4.514-1.616
	s2.45,2.732,1.662,4.391C70.121,38.365,68.1,39.088,66.394,38.323z'
      />
      <path
        fill='#89B9E0'
        d='M54.907,44.828c-0.829,0.074-1.561-0.52-1.637-1.325c-0.075-0.806,0.535-1.518,1.363-1.591
	c0.828-0.074,1.561,0.52,1.636,1.325C56.345,44.042,55.735,44.754,54.907,44.828z'
      />
      <path
        fill='#D17363'
        d='M57.74,4.688c-0.744,0.065-1.401-0.467-1.469-1.191c-0.068-0.723,0.48-1.363,1.224-1.429
	c0.744-0.066,1.401,0.467,1.469,1.19C59.032,3.981,58.484,4.621,57.74,4.688z'
      />
      <path
        fill='#C85248'
        d='M59.668,11.07c-0.828,0.074-1.561-0.52-1.636-1.325c-0.075-0.805,0.535-1.518,1.363-1.592
	c0.829-0.073,1.561,0.521,1.637,1.326C61.107,10.284,60.497,10.997,59.668,11.07z'
      />
      <path
        fill='#645C8A'
        d='M61.22,18.077c-0.999,0.256-2.022-0.324-2.286-1.295c-0.263-0.972,0.333-1.967,1.332-2.223
	c0.999-0.256,2.022,0.324,2.285,1.295C62.815,16.826,62.219,17.821,61.22,18.077z'
      />
      <path
        fill='#56A3D5'
        d='M59.826,41.169c-0.999,0.256-2.022-0.324-2.286-1.295c-0.263-0.972,0.333-1.967,1.332-2.223
	c0.999-0.256,2.022,0.324,2.286,1.295S60.825,40.914,59.826,41.169z'
      />
      <path
        fill='#2073AE'
        d='M61.903,35.235c-1.435,0.127-2.704-0.9-2.834-2.295c-0.13-1.396,0.926-2.63,2.361-2.757
	s2.704,0.9,2.834,2.296C64.394,33.874,63.337,35.108,61.903,35.235z'
      />
      <path
        fill='#264983'
        d='M62.114,27.754c-1.871,0.166-3.525-1.175-3.696-2.995c-0.171-1.819,1.208-3.429,3.079-3.595
	c1.871-0.166,3.526,1.175,3.697,2.994C65.363,25.979,63.985,27.588,62.114,27.754z'
      />
      <path
        fill='#89B9E0'
        d='M30.784,42.343c0.68-0.466,1.619-0.309,2.099,0.353c0.479,0.661,0.317,1.574-0.362,2.041
	c-0.68,0.467-1.619,0.309-2.099-0.352C29.943,43.724,30.105,42.81,30.784,42.343z'
      />
      <path
        fill='#D17363'
        d='M48.967,78.484c0.61-0.419,1.454-0.277,1.885,0.316c0.43,0.593,0.285,1.414-0.325,1.832
	c-0.61,0.419-1.454,0.277-1.884-0.316C48.211,79.724,48.357,78.902,48.967,78.484z'
      />
      <path
        fill='#C85248'
        d='M44.015,73.895c0.68-0.467,1.619-0.31,2.099,0.353c0.479,0.66,0.317,1.574-0.362,2.04
	c-0.679,0.467-1.619,0.309-2.098-0.352C43.173,75.274,43.335,74.36,44.015,73.895z'
      />
      <path
        fill='#645C8A'
        d='M39.07,68.581c0.733-0.708,1.917-0.703,2.645,0.01c0.728,0.714,0.723,1.866-0.011,2.573
	s-1.918,0.703-2.646-0.011C38.331,70.44,38.336,69.288,39.07,68.581z'
      />
      <path
        fill='#56A3D5'
        d='M28.405,47.904c0.733-0.708,1.917-0.703,2.645,0.011s0.723,1.865-0.011,2.573
	c-0.733,0.707-1.918,0.703-2.646-0.011C27.667,49.763,27.671,48.611,28.405,47.904z'
      />
      <path
        fill='#2073AE'
        d='M29.657,54.053c1.177-0.808,2.805-0.535,3.635,0.61c0.831,1.145,0.55,2.728-0.627,3.535
	c-1.177,0.808-2.804,0.535-3.635-0.61S28.48,54.861,29.657,54.053z'
      />
      <path
        fill='#264983'
        d='M33.32,60.635c1.535-1.054,3.658-0.698,4.741,0.795s0.717,3.557-0.818,4.61
	c-1.535,1.054-3.657,0.698-4.74-0.795C31.419,63.752,31.785,61.688,33.32,60.635z'
      />
    </SvgIcon>
  )
}

type Sizes = 'small' | 'medium' | 'large' | 'inherit' | undefined

export default function SvgSbirSttrLogoIcon({
  width,
  height,
  fs,
  m,
}: {
  width: string
  height: string
  fs?: Sizes
  m?: number
}) {
  return (
    <SbirSttrLogoIcon
      viewBox={`0 0 ${width} ${height}`}
      fontSize={fs ?? 'medium'}
      sx={{m: m ?? 0}}
    />
  )
}
